import api, { extractError } from "api/api";

export const fetchRestaurant = ({ queryKey }: any) => {
  const [_key, id] = queryKey;

  return api
    .get(`/api/v2/restaurants/${id}`)
    .then((resp) => {
      return resp.data?.restaurant;
    })
    .catch((e) => {
      throw extractError(e);
    });
};
